export var AppEvent;
(function (AppEvent) {
    AppEvent["CREATED"] = "CREATED";
    AppEvent["UPDATED"] = "UPDATED";
})(AppEvent || (AppEvent = {}));
//# sourceMappingURL=types.js.map